<template>
    <div id="myapp">
      <!-- Sidebar and Main Content -->
      <div class="appClass">
        <!-- Sidebar -->
        <div :class="['sidebar', { 'sidebar-open': isSidebarOpen }]">
          <div style="text-align: center;">
            <h3 style="color: white; padding: 10px;">Tution Wave</h3>
            <hr style="border: 1px solid white; width: 80%; margin: 0 auto;" />
          </div>
  
          <!-- <button class="btn btn-secondary close-btn" @click="toggleSidebar">
            <i class="bi" :class="isSidebarOpen ? 'bi-x' : 'bi-list'"></i>
          </button> -->
          <div class="sidebar-content">
            <ul>
              <!-- Icons only when sidebar is closed -->
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('home')"><i class="bi bi-house-door"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('profile')"><i class="bi bi-person"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('students')"><i class="bi bi-people"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('add-students')"><i class="bi bi-person-plus"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('payments')"><i class="bi bi-cash-coin"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('get-qr')"><i class="bi bi-qr-code-scan"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('settings')"><i class="bi bi-gear"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('about')"><i class="bi bi-info-circle"></i></a></li>
              <!-- Icons and text when sidebar is open -->
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('home')"><i class="bi bi-house-door"></i>Home</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('profile')"><i class="bi bi-person"></i>Profile</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('students')"><i class="bi bi-people"></i>Students</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('add-students')"><i class="bi bi-person-plus"></i>Add Students</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('payments')"><i class="bi bi-cash-coin"></i>Payments</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('get-qr')"><i class="bi bi-qr-code-scan"></i>Get QR</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('settings')"><i class="bi bi-gear"></i>Settings</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('about')"><i class="bi bi-info-circle"></i>About</a></li>
            </ul>
          </div>
        </div>
  
        <!-- Main Content -->
        <main :class="['main-content', { 'shift-right': isSidebarOpen }]">
          <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <div style="display: flex;">
            <a v-show="!isSidebarOpen" class="navbar-brand appName" href="#">Tution Wave</a>
            <button class="btn btn-primary ms-auto" @click="toggleSidebar">
              <i class="bi" :class="isSidebarOpen ? 'bi-x' : 'bi-list'"></i> <!-- Toggle icon -->
            </button>
            </div>
            <a class="navbar-brand appNameA" href="#">Tution Wave</a>
            <div class="collapse navbar-collapse" id="navbarNav">
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a class="nav-link active" aria-current="page" href="#"><i class="bi bi-house-door"></i> Home</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#"><i class="bi bi-star"></i> Features</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#"><i class="bi bi-cash"></i> Pricing</a>
                </li>

              </ul>
              <div class="appNameB">
                <h3>Tution Wave</h3>
            </div>


            </div>


            <div class="loginHeader desktop-only">
                <LoginHeader/>
            </div>

            <div v-show="!isSidebarOpen" class="loginHeader mobile-only">
                <LoginHeader/>
            </div>
          </nav>
  
          <div>
            <div class="main-content">
              <div class="sub-content" v-if="currentPage === 'home'">
                <HomeView/>
              </div>
              <div class="sub-content" v-if="currentPage === 'settings'">
                <SettingsView/>
              </div>
              <div class="sub-content" v-if="currentPage === 'about'">
                <AboutView/>
              </div>
            </div>
          </div>
  
          <!-- Add your main content here -->
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import LoginHeader from '@/components/LoginHeader.vue';
  import HomeView from '@/components/HomeView.vue';
  import SettingsView from '@/components/SettingsView.vue';
  import AboutView from '@/components/AboutView.vue';
  
  export default {
    components: {
        LoginHeader,
        HomeView,
        SettingsView,
        AboutView,
    },
    data() {
      return {
        isSidebarOpen: false,
        currentPage: 'home',
      };
    },
    methods: {
      toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
      },
      showPage(page) {
        this.currentPage = page;
      },
    },
  };
  </script>
  
  <style scoped>
#myapp {
  width: 100vw; /* Full viewport width */
  height: 100vh; /* Full viewport height */
  background-color: #333;
  display: flex;
  flex-direction: column;
}


  .appName{
    display: none;
  }

  .appNameA{
    display: none;
  }

  .appNameB{
    margin-left: 20%;
  }
  
  .appClass {
    display: flex;
    flex: 1;
  }
  
  .sidebar {
    position: fixed;
    top: 0;
    left: 0; /* Start from the left edge */
    width: 60px; /* Compact width */
    height: 100%; /* Use viewport height for full height */
    background-color: black;
    transition: width 0.3s ease;
    overflow: hidden;
    white-space: nowrap;
  }
  
  .sidebar-open {
    width: 260px; /* Expanded width */
    overflow: hidden; /* Prevent scrolling if the content overflows */
  }
  
  .sidebar-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
  }
  
  .sidebar-content ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .sidebar-content li {
    margin: 10px 0;
  }
  
  .sidebar-content a {
    color: white;
    text-decoration: none;
    font-size: 1.5rem;
    gap: 10px;
    display: flex;
    align-items: center;
    padding: 10px; /* Add padding for better hover effect */
    transition: background-color 0.3s ease, color 0.3s ease; /* Smooth transition for hover effects */
  }
  
  .sidebar-content a:hover {
    background-color: #555; /* Background color on hover */
    color: #f0f0f0; /* Text color on hover */
  }
  
  .sidebar-content a span {
    margin-left: 10px;
  }
  
  .sidebar-open .sidebar-content a {
    font-size: 1rem;
  }
  
  .main-content {
    flex: 1;
    margin-left: 0;
    /* margin-left: 60px; */
    transition: margin-left 0.3s ease;
  }

  .sub-content{
    margin-top: 60px !important;
    margin-left: 60px !important;
  }

  
  .shift-right {
    margin-left: 260px; /* Adjust content position */
    transition: margin-left 0.3s ease; /* Smooth transition for margin-left */
  }
  
  .navbar {
    position: fixed;
    width: 100%;
    /* height: 56px; */
    margin-bottom: 1rem;
    padding-left: 15px;
    gap: 10px;
  }

  .sidebar-open + .main-content .loginHeader {
  margin-right: 265px;
}

  .loginHeader {
    transition: margin-right 0.3s ease; /* Smooth transition for margin-right */
  margin-right: 5px; /* Remove margin if it's pushing the header out of view */
}

.mobile-only {
  display: none; /* Hide by default (desktop) */
}



  
  .close-btn {
    margin: 10px;
  }
  
  @media (max-width: 769px) {

    .appName{
    display: block;
  }

    .appNameB{
        display: none;
  }

  .mobile-only {
    display: block; /*Login Header Show only in mobile view */
  }

  .desktop-only{
    display: none;
  }
  
  }
  </style>
  